export default "__VITE_ASSET__CieKbnpX__"